import React, { useState } from "react";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { Copy, Check } from "lucide-react";

export function SuccessView({ slug, password, onBack }: { slug: string; password: string; onBack: () => void }) {
    const url = `${window.location.origin}/prototypes/v/${slug}`;
    const [copied, setCopied] = useState<"url" | "pw" | null>(null);

    const copy = (text: string, which: "url" | "pw") => {
        void navigator.clipboard.writeText(text);
        setCopied(which);
        setTimeout(() => setCopied(null), 2000);
    };

    return (
        <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
                <Check className="h-8 w-8 text-green-600" />
            </div>
            <h2 className="mb-2 text-2xl font-bold">Prototype published!</h2>
            <p className="mb-8 text-muted-foreground">Your prototype is now live and ready to share.</p>

            <Card className="w-full max-w-md">
                <CardContent className="space-y-4 p-6">
                    <div>
                        <p className="text-sm text-muted-foreground">Prototype URL</p>
                        <div className="mt-1 flex items-center justify-between gap-2">
                            <code className="flex-1 overflow-hidden text-ellipsis rounded bg-muted px-2 py-1 text-sm">
                                {url}
                            </code>
                            <Button variant="ghost" size="icon" onClick={() => copy(url, "url")}>
                                {copied === "url" ? (
                                    <Check className="h-4 w-4 text-green-500" />
                                ) : (
                                    <Copy className="h-4 w-4" />
                                )}
                            </Button>
                        </div>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Password for viewers</p>
                        <div className="mt-1 flex items-center justify-between gap-2">
                            <code className="flex-1 rounded bg-muted px-2 py-1 text-sm">{password}</code>
                            <Button variant="ghost" size="icon" onClick={() => copy(password, "pw")}>
                                {copied === "pw" ? (
                                    <Check className="h-4 w-4 text-green-500" />
                                ) : (
                                    <Copy className="h-4 w-4" />
                                )}
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>

            <Button onClick={onBack} className="mt-8">
                Back to dashboard
            </Button>
        </div>
    );
}
